import { IconButton, Theme } from '@mui/material';
import { MouseEvent } from 'react';
import { UserRole } from '@synergy/models';
import { WithStyles, createStyles, withStyles } from '@mui/styles';
import EditIcon from '@mui/icons-material/Edit';

import { AccessControl } from '../access-control/access-control';

const styles = (theme: Theme) =>
    createStyles({
        footerRight: {
            textAlign: 'right',
        },
        footerButton: {
            textTransform: 'uppercase',
            padding: theme.spacing(2, 3),

            '& svg': {
                marginRight: theme.spacing(),
            },
        },
    });

interface PoolAutocompleteListActionProps extends WithStyles<typeof styles> {
    url: string;
    allowedRoles?: UserRole | UserRole[];
}

const PoolAutocompleteListActionBase = (props: PoolAutocompleteListActionProps) => {
    const stopPropagation = (event: MouseEvent) => event.stopPropagation();

    return (
        <AccessControl allowedRoles={props.allowedRoles}>
            <IconButton href={props.url} target="_blank" onClick={stopPropagation}>
                <EditIcon />
            </IconButton>
        </AccessControl>
    );
};

export const PoolAutocompleteListAction = withStyles(styles)(PoolAutocompleteListActionBase);
